import TrueFalseQuestionTemplate from '~/pages/anatomyV2/libs/components/TrueFalseQuestionTemplate'
import {
  spotTheFakePNG,
  spotTheFakeWEBP,
} from '~/pages/anatomyV2/spotTheFake/constants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 2

const SpotTheFakeAnatomyV2 = (props: TPageProps) => (
  <TrueFalseQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.spotTheFake.title"
    factI18nKey="onboarding.spotTheFake.fact"
    questionImagePNG={spotTheFakePNG}
    questionImageWEBP={spotTheFakeWEBP}
    questionImageAlt="Foot muscles and bones"
    question="Spot the fake: feet bones"
  />
)

export default SpotTheFakeAnatomyV2
